import React from 'react';

import type { FlagProps } from '../types';

const FlagKg = ({ className, testID }: FlagProps) => (
  <svg
    width={20}
    height={15}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid={testID}
    className={className}
    aria-hidden="true"
  >
    <mask
      id="prefix__a"
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={20}
      height={15}
    >
      <path fill="#fff" d="M0 0h20v15H0z" />
    </mask>
    <g mask="url(#prefix__a)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0v15h20V0H0z"
        fill="#C51918"
      />
      <mask
        id="prefix__b"
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={20}
        height={15}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#prefix__b)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.989 11.167c.067 0 .133-.002.2-.005l.385 1.23.09-1.285c.129-.024.255-.054.38-.09l.66 1.109-.212-1.271c.12-.053.236-.11.349-.175l.902.929-.503-1.19a3.56 3.56 0 0 0 .298-.248l1.094.697-.765-1.043c.083-.099.16-.202.233-.31l1.226.429-.986-.84a3.61 3.61 0 0 0 .155-.354l1.291.136-1.154-.59a3.68 3.68 0 0 0 .068-.382l1.288-.163-1.26-.31a4.105 4.105 0 0 0-.022-.387l1.214-.453-1.296-.014a3.644 3.644 0 0 0-.112-.372l1.075-.718-1.264.283a3.68 3.68 0 0 0-.195-.337l.878-.944-1.163.564a3.743 3.743 0 0 0-.269-.283l.635-1.119-1 .814a3.744 3.744 0 0 0-.328-.215l.358-1.232-.782 1.019a3.73 3.73 0 0 0-.371-.135l.061-1.278-.524 1.17a3.777 3.777 0 0 0-.392-.046L9.993 2.5l-.237 1.257a3.779 3.779 0 0 0-.394.045L8.84 2.634l.062 1.276a3.73 3.73 0 0 0-.373.134l-.78-1.016.356 1.227a3.747 3.747 0 0 0-.332.216l-.995-.81.632 1.113c-.095.09-.186.186-.272.286L5.98 4.5l.874.937a4 4 0 0 0-.2.341L5.4 5.497l1.068.713a3.655 3.655 0 0 0-.113.377l-1.288.014 1.206.45a3.91 3.91 0 0 0-.022.392L5 7.751l1.279.162c.016.131.039.26.069.386L5.2 8.886l1.283-.135c.046.123.099.243.157.36l-.98.833 1.22-.426c.072.109.151.213.235.313l-.76 1.037 1.088-.694c.096.089.196.172.301.25l-.5 1.185.899-.925c.113.064.23.122.35.174l-.21 1.268.659-1.107c.124.036.252.066.381.09l.09 1.282.385-1.229c.063.003.127.005.19.005zm2.812-3.72c0 1.553-1.269 2.812-2.835 2.812-1.565 0-2.835-1.259-2.835-2.812s1.27-2.812 2.835-2.812c1.566 0 2.835 1.26 2.835 2.812zm-.857.916a2.136 2.136 0 0 0 .008-1.722c-.49.035-.904.164-1.24.329.746.326 1.084.864 1.232 1.393zm-.241.411c-.061.082-.128.16-.2.232-.04-.738-.355-1.3-.922-1.908.701.336 1.097 1.138 1.122 1.676zm-.537.507a2.14 2.14 0 0 1-.121.075c-.168-.829-.487-1.483-.93-2.006l.107-.081.044-.032c.567.652.925 1.212.9 2.044zm-1.181.355c.251 0 .492-.043.717-.123-.163-.789-.447-1.523-.858-2.053a3.062 3.062 0 0 0-.75 1.983c.272.124.573.193.89.193zm-.413-2.43.049.04c-.523.594-.809 1.265-.858 2.009a2.152 2.152 0 0 1-.184-.144c.197-.787.523-1.436.993-1.905zm-1.56-.55c.49.055.878.174 1.169.313-.74.314-1.033.822-1.18 1.339a2.137 2.137 0 0 1 .01-1.652zm.268 2.137a2.164 2.164 0 0 1-.048-.066c.037-.543.383-1.314 1.081-1.632A3.74 3.74 0 0 0 8.28 8.793zm.159-2.784a2.138 2.138 0 0 1 3.073-.02c-.612.072-1.13.225-1.552.464-.375-.216-.883-.361-1.521-.444z"
          fill="#FFDC17"
        />
      </g>
    </g>
  </svg>
);
export default FlagKg;
